<template>
    <div>
        <b-row>
            <b-col cols="9">
                <b-row>
                    <b-col class="workspace-header">
                        <h1 class="text-right"><i class="fa-duotone fa-file-invoice-dollar fa-fw"></i> Offer Generation</h1>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <div class="scan-graphic d-flex flex-column justify-content-center align-items-center">
                            <i class="fa-duotone fa-scanner fa-10x scanner-icon"></i>
                            <div class="display-4 mt-4 text-muted">Scan Package to Begin</div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>


            <b-col cols="3">
                <dashboard-side-data-widget label="Ready For Generation"
                                            :data="dashboardData.ordersOfferGenStatus"
                                            colorData="warning"
                                            icon="fa-light fa-pallet-alt">
                </dashboard-side-data-widget>

                <dashboard-side-data-widget label="Offers Generated"
                                            :data="dashboardData.ordersOfferReadyStatus"
                                            colorData="success"
                                            icon="fa-light fa-box-full">
                </dashboard-side-data-widget>

                <dashboard-side-data-widget label="Orders in Appraisal Hold"
                                            to="/search?filterField_0=status_id&filterModel_0=order&filterName_0=Order%20Status&filterParameter_0=equals&&filterValue_0=6"
                                            :data="dashboardData.ordersHoldStatus"
                                            colorData="danger"
                                            icon="fa-light fa-archive">
                </dashboard-side-data-widget>

            </b-col>
        </b-row>
    </div>
</template>

<script>
import _, {assign} from 'lodash';
import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
import {BROADCAST_CONNECTED} from '@/store/actions';

export default {
    name: 'offer-generation-scan',
    components: {DashboardSideDataWidget},
    data() {
        return {
            isSaving: false,
            loading: false,
            working: false,
            dashboardData: {
                ordersOfferGenStatus: null,
                ordersOfferReadyStatus: null,
                ordersHoldStatus: null,
            },
        };
    },
    created() {

    },
    mounted() {
        this.getDashboardData();

        console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
        if (! this.$store.getters.isBroadcastConnected) {
            this.$store.subscribe((mutation) => {
                console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                if (mutation.type === BROADCAST_CONNECTED) {
                    console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                    this.joinBroadcastChannel();
                }
            });
        } else {
            console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
            this.joinBroadcastChannel();
        }

        this.$barcodeScanner.init((rawBarcode) => {
            this.$barcodeScanner.parseBarcode(rawBarcode, barcode => {
                this.$router.push({path: '/offer-generation/view/' + encodeURIComponent(barcode)});
            });
        });
    },
    beforeDestroy() {
        console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.OfferGeneration channel from OfferGeneration/index.vue.');
        this.$echo.leaveChannel('App.OfferGeneration');
        this.$barcodeScanner.destroy();
    },
    methods: {
        joinBroadcastChannel: function () {
            console.info(String.fromCodePoint(0x1F91D) + ' Joining App.OfferGeneration channel from OfferGeneration/index.vue.');
            this.$echo.channel('App.OfferGeneration')
                .listen('BroadcastDashboardUpdate', (e) => {
                    this.dashboardData = assign(this.dashboardData, e.payload);
                });
        },
        getDashboardData(){
            this.$http.get('/dashboards/OfferGen').then((response) => {
                this.dashboardData = assign(this.dashboardData, response.data.data);
            });
        },
    },
    computed: {

    },
};
</script>

<style scoped>
.table-input {
    max-width: 80px;
    text-align: right;
}

.table-img {
    max-width: 100px;
}

.editable .controls .fa-solid {
    font-size: 18px;
    transition: .2s ease;
}

.editable .controls .fas:hover {
    transform: scale(1.2);
}

.editable .data {
    position: relative;
}

.editable .data:hover {
    background: #f6f6f6;
    cursor: pointer;
}

.editable .data:hover:after {
    font-family: 'FontAwesome';
    content: "\f14b";
    position: absolute;
    right: 4px;
    top: 0;
    color: lightcoral;
    font-size: 12px;
}

i.scanner-icon {
    font-size: 18rem;
    color: gray;
}

.scan-graphic {
    height: 75vh;
}
</style>
